import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";
import { ButtonStyled, DivRowStyled, SearchInputStyled, SpanSpacerStyled } from "./ProductsToolbar.styles";
const ProductsToolbar = ({ className }) => {
  return /* @__PURE__ */ React.createElement("div", { className }, /* @__PURE__ */ React.createElement(DivRowStyled, null, /* @__PURE__ */ React.createElement(SpanSpacerStyled, null), /* @__PURE__ */ React.createElement(ButtonStyled, null, "Import"), /* @__PURE__ */ React.createElement(ButtonStyled, null, "Export"), /* @__PURE__ */ React.createElement(Button, null, "Add product")), /* @__PURE__ */ React.createElement(DivRowStyled, null, /* @__PURE__ */ React.createElement(SearchInputStyled, { placeholder: "Search product" })));
};
ProductsToolbar.propTypes = {
  className: PropTypes.string
};
export default ProductsToolbar;
